import {FirebaseApp, initializeApp} from "firebase/app";
import {getAnalytics, logEvent, setUserProperties} from "firebase/analytics";
import daysjs from 'dayjs';
import {KEYS} from "../utils/constants";
import {useAppSelector} from "../Redux/hooks";
import { store } from "../Redux/store";

export const initFirebase = () => {
    const firebaseConfig = KEYS.FIREBASE_CONFIG;
    initializeApp(firebaseConfig);
};

/**
 *
 * LogEvent Method used to log events
 *
 * @param name
 * @param parameters
 */
export const fbLogEvent = (name : string, parameters : object) => {

    const storeData = store.getState();
    const shipmentId = storeData.global.id || undefined;
    const carrierId = storeData.global.carrierId || undefined;
    const role = storeData.global.role || undefined;
    const session = getSessionId(shipmentId || "");
    const mode = storeData.global.mode || undefined;
    let params: any = parameters;
    params = {
        ... params,
        ...(typeof shipmentId !== 'undefined' ? { shipmentId } : {}),
        ...(typeof carrierId !== 'undefined' ? { carrierId } : {}),
        ...(typeof role !== 'undefined' ? { role: role } : {}),
        ...(typeof session !== 'undefined' ? { sessionId: session} : {}),
    };

    // Initialize Analytics and get a reference to the service
    const analytics = getAnalytics();
    logEvent(analytics, name, params);

    // Role based Cohorts Firebase Analytics implementation
    setUserProperties(analytics, {User_Role: role});
};

const getSessionId = (id : string) : string => {
    return id + daysjs(new Date()).format('MMDDYYYYHHmmss');
};